/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_CtaInputs */

const en_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Regions`)
};

const de_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionen vergleichen`)
};

const fr_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer les régions`)
};

const es_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar regiones`)
};

const it_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta regioni`)
};

const nl_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regio's vergelijken`)
};

const pl_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównaj regiony`)
};

const fi_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaa alueita`)
};

const da_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign regioner`)
};

const sv_salary_compare_cta = /** @type {(inputs: Salary_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämför regioner`)
};

/**
* | output |
* | --- |
* | "Compare Regions" |
*
* @param {Salary_Compare_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_cta = /** @type {((inputs?: Salary_Compare_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_cta(inputs)
	if (locale === "fr") return fr_salary_compare_cta(inputs)
	if (locale === "es") return es_salary_compare_cta(inputs)
	if (locale === "it") return it_salary_compare_cta(inputs)
	if (locale === "nl") return nl_salary_compare_cta(inputs)
	if (locale === "pl") return pl_salary_compare_cta(inputs)
	if (locale === "fi") return fi_salary_compare_cta(inputs)
	if (locale === "da") return da_salary_compare_cta(inputs)
	if (locale === "sv") return sv_salary_compare_cta(inputs)
	return en_salary_compare_cta(inputs)
});